var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Body, H3 } from "@irati/ui/src/Typography";
import authentication from "@irati/auth";
import { Hr } from "@irati/ui/src/Layout";
import Markdown from "@irati/ui/src/Markdown";
import Flex from "@irati/ui/src/Flex";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import PerksGOImportantInfo from "@irati-web/perksgo/src/components/PerksGOImportantInfo";
import RedemptionEventImportantInfo from "@irati-web/perks/src/components/RedemptionEventImportantInfo";
import AppOnlyImportantInfo from "@irati-web/perks/src/components/AppOnlyImportantInfo";
import { isUserDOBRequired } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import BoostedSaving from "@irati-web/perks/src/components/BoostedSaving";
import ExternalURLCTA from "@irati-web/perks/src/components/ExternalURLCTA";
import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import hasPerksGOLocations from "@irati/deals/helpers/deals/hasPerksGOLocations";
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly";
import { COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS } from "@irati/deals/constants/dealType";
import { ButtonLink, ButtonRouterLink } from "@irati/ui/src/Link";
import tracking from "@irati-tracking/perks/perks";
import { connect } from "@irati/store";
import getCurrency from "@irati/deals/helpers/deals/currency";
import isBoostedPerk from "@irati/deals/helpers/deals/isBoostedPerk";
import { shouldShowRedemptionButton } from "@irati/deals/helpers/deals/restrictions";
import trimProtocolFromUrl from "@irati/deals/helpers/deals/trimProtocolFromUrl";
import isWalletBalanceApplicable from "@irati/deals/helpers/isWalletBalanceApplicable";
import isTimeLimited from "@irati/deals/helpers/deals/isTimeLimited";
import Button from "@irati/ui/src/Button";
import Modal from "@irati/ui/src/Modal/Modal";
import visaLogo from "@irati-web/payments/src/images/visa.svg";
import mastercardLogo from "@irati-web/payments/src/images/mastercard.svg";
import zipLogo from "@irati-web/payments/src/images/zip-homepage.svg";
import ZipReadMoreAndModal from "@irati-web/payments/src/components/ZipModal/ZipReadMoreAndModal";
import { ZipImage } from "@irati-web/payments/src/components/ZipModal/styled";
import ImportantInfoList from "../ImportantInfoList";
import Saving from "../Saving";
import Wrapper from "./styled/Wrapper";
import DEAL_PAGES from "../../constants/dealPage";
import NearestLocation from "./NearestLocation";
import { StyledWalletSpendBalance, Image } from "./styled/ImportantInfoBlock";
import TimeLimitedDeal from "./TimeLimitedDeal";
import FavouriteButton from "./styled/FavouriteButton";
import TeCModalHeader from "./TeCModalHeader";
import UnavailableDeal from "./UnavailableDeal";
var renderRedemptionButton = function (_a) {
    var _b, _c;
    var deal = _a.deal, onClick = _a.onClick, buttonDisabled = _a.buttonDisabled, buttonText = _a.buttonText, wallet = _a.wallet, props = __rest(_a, ["deal", "onClick", "buttonDisabled", "buttonText", "wallet"]);
    if (isPerksGO(deal)) {
        return null;
    }
    if (shouldShowRedemptionButton(deal)) {
        var RedemptionButton = (React.createElement("div", null,
            React.createElement(Flex, { direction: "row", justifyContent: "center", alignContent: "center" },
                React.createElement(Body, null, isWalletBalanceApplicable(deal, wallet)
                    ? React.createElement(FormattedMessage, { id: "perks.zip.payWithWalletBalance" })
                    : React.createElement(FormattedMessage, { id: "perks.zip.payZipWithoutWalletBalance" }))),
            React.createElement("section", null,
                React.createElement(Flex, { justifyContent: "center", alignContent: "center", marginBottom: 1 },
                    React.createElement(Image, { src: mastercardLogo }),
                    React.createElement(Image, { src: visaLogo })),
                ((_c = (_b = deal.paymentOptions) === null || _b === void 0 ? void 0 : _b.zip) === null || _c === void 0 ? void 0 : _c.enabled) && (React.createElement(Flex, { justifyContent: "space-between", alignContent: "center", marginBottom: 2 },
                    React.createElement(ZipImage, { src: zipLogo }),
                    React.createElement(ZipReadMoreAndModal, null)))),
            React.createElement(Flex, null,
                React.createElement(ButtonRouterLink, { id: id("getThisPerk", props), primary: true, large: true, full: true, async: true, disabled: !!buttonDisabled, onClick: onClick, marginBottom: 2 }, buttonText))));
        if (isWalletBalanceApplicable(deal, wallet)) {
            return React.createElement(StyledWalletSpendBalance, null, RedemptionButton);
        }
        else {
            return (React.createElement("section", null,
                React.createElement(Hr, null),
                isTimeLimited(deal) && React.createElement(TimeLimitedDeal, { deal: deal }),
                RedemptionButton));
        }
    }
    return null;
};
var ImportantInfoBlock = /** @class */ (function (_super) {
    __extends(ImportantInfoBlock, _super);
    function ImportantInfoBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isModalOpen: false
        };
        _this.openModal = function (deal) {
            tracking.viewTerms(deal);
            _this.setState({ isModalOpen: true });
        };
        _this.closeModal = function () {
            _this.setState({ isModalOpen: false });
        };
        _this.handleFavChange = function (isFavourite) {
            return isFavourite ? tracking.favouritePerk(_this.props.deal, DEAL_PAGES.PERK) : tracking.unfavouritePerk(_this.props.deal, DEAL_PAGES.PERK);
        };
        _this.showLocations = function () {
            return (authentication.apps("platform.geoLocation") &&
                authentication.apps("perks.perksGo") &&
                hasPerksGOLocations(_this.props.deal) &&
                !_this.props.isMobile);
        };
        _this.isPerksGoDeal = function () {
            return authentication.apps("perks.perksGo") && isPerksGO(_this.props.deal);
        };
        return _this;
    }
    ImportantInfoBlock.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, importantListData = _c.importantListData, termsAndConditions = _c.termsAndConditions, userSavings = _c.userSavings, deal = _c.deal, formatMessage = _c.formatMessage, children = _c.children, buttonText = _c.buttonText, buttonDisabled = _c.buttonDisabled, onClick = _c.onClick;
        var isModalOpen = this.state.isModalOpen;
        var savingHeader = deal.type === DEAL_TYPE_COMPANY_BENEFITS
            ? formatMessage({ id: "perks.components.importantInfoBlock.importantInfoBlock.save" })
            : userSavings.header;
        var brandName = deal.brandName || formatMessage({ id: "perks.importantInfoBlock.externalURLCTA.brandName.fallback" });
        var websiteUrl = deal.websiteUrl, externalLoginUrl = deal.externalLoginUrl;
        var trimmedWebsiteUrl = websiteUrl ? trimProtocolFromUrl(websiteUrl) : null;
        return (React.createElement(Row, null,
            React.createElement(Wrapper, { addPadding: true },
                React.createElement("section", { className: "importantInfoBlock_header" },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 6 },
                            React.createElement(H3, null,
                                React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.importantText" }),
                                React.createElement("br", null),
                                React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.infoText" }))),
                        isBoostedPerk(deal) && (React.createElement(Col, { xs: 6 },
                            React.createElement(BoostedSaving, { userSavings: (_a = deal === null || deal === void 0 ? void 0 : deal.savings) === null || _a === void 0 ? void 0 : _a.userSavings, boostedSavings: (_b = deal === null || deal === void 0 ? void 0 : deal.savings) === null || _b === void 0 ? void 0 : _b.boostedSavings }))),
                        (userSavings && !isBoostedPerk(deal)) && (React.createElement(Col, { xs: 6 },
                            React.createElement(Saving, { saving: userSavings.value, type: userSavings.type, currency: getCurrency(deal), header: savingHeader }))))),
                React.createElement(Hr, null),
                !isEmpty(importantListData) && (React.createElement("section", null,
                    React.createElement(ImportantInfoList, { data: importantListData }))),
                this.showLocations() && (React.createElement("section", null,
                    React.createElement(NearestLocation, { deal: deal }))),
                websiteUrl && (React.createElement("section", { id: id("websiteUrl", this.props) },
                    React.createElement(Hr, null),
                    React.createElement(Flex, { justifyContent: "center" },
                        React.createElement(ButtonLink, { cta: true, href: websiteUrl, target: "_blank" }, trimmedWebsiteUrl)))),
                isDealUnavailable(deal) && (React.createElement("section", null,
                    React.createElement(UnavailableDeal, null))),
                termsAndConditions && (React.createElement("section", { "data-test": "tandcs", className: "importantInfoBlock_t-and-cs" },
                    React.createElement(Hr, null),
                    React.createElement(Flex, { justifyContent: "center", marginBottom: 1.5 },
                        React.createElement(Button, { cta: true, onClick: function () { return _this.openModal(deal); } },
                            React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.tAndC" }))),
                    React.createElement(Modal, { show: isModalOpen, onHide: this.closeModal, renderHeader: TeCModalHeader },
                        React.createElement(Markdown, { source: termsAndConditions }),
                        React.createElement(Flex, { justifyContent: "flex-end", marginTop: 3 },
                            React.createElement(Button, { primary: true, onClick: this.closeModal },
                                React.createElement(FormattedMessage, { id: "perks.components.simpleModal.close" })))))),
                !isDealUnavailable(deal) && (React.createElement(React.Fragment, null,
                    isUserDOBRequired(deal) && (React.createElement(RedemptionEventImportantInfo, { deal: deal, buttonText: buttonText, buttonDisabled: buttonDisabled, emoji: "\uD83C\uDF82", onClick: onClick })),
                    renderRedemptionButton(this.props),
                    isAppOnly(deal) && React.createElement(AppOnlyImportantInfo, { includeSubHeader: true }),
                    externalLoginUrl && (React.createElement(ExternalURLCTA, { callToAction: formatMessage({ id: "perks.importantInfoBlock.externalURLCTA.header" }, { brandName: brandName }), buttonText: formatMessage({ id: "perks.importantInfoBlock.externalURLCTA.buttonText" }), buttonHref: externalLoginUrl })),
                    this.isPerksGoDeal() && React.createElement(PerksGOImportantInfo, { deal: deal }))),
                React.createElement(FavouriteButton, { deal: deal, onChange: this.handleFavChange }),
                children)));
    };
    ImportantInfoBlock.defaultProps = {
        id: "importantInfoBlock",
        deal: null,
        termsAndConditions: null,
        userSavings: null,
        children: null
    };
    return ImportantInfoBlock;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq, wallet = _a.wallet;
    return {
        isMobile: mq.lessThan.large,
        wallet: wallet
    };
};
export default injectIntl(connect(mapStateToProps)(ImportantInfoBlock));
